import { Typography, IconButton, Grid } from '@mui/material';
import ViewDocumentIcon from 'assets/icons/view-document-icon.svg?react';
import DeleteDocumentIcon from 'assets/icons/delete-document-icon.svg?react';
import PdfIcon from 'assets/icons/pdf-icon.svg?react';

interface DocumentDescriptionProps {
  file: File | null;
  setFile: (file: File | null) => void;
}

const containerStyle = {
  display: 'flex',
  alignItems: 'center',
  padding: 0,
  mt: 1,
};

const DocumentDescription = ({ setFile, file }: DocumentDescriptionProps) => {
  const openDocument = (fileToOpen: File) => {
    const blob = new Blob([fileToOpen], { type: 'application/pdf' });
    const objectUrl = URL.createObjectURL(blob);
    window.open(objectUrl);
  };

  return (
    <Grid container sx={containerStyle} data-testid={'document-description-container'}>
      <Grid container>
        <Typography variant="body2">Name</Typography>
      </Grid>
      <Grid
        item
        xs={8}
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          mt: 1,
        }}
      >
        {file && (
          <Typography
            variant="body2"
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <PdfIcon style={{ marginRight: '1em' }} />
            {file.name}
          </Typography>
        )}
      </Grid>
      <Grid
        item
        xs={4}
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <IconButton sx={{ display: 'flex', alignItems: 'center' }} onClick={() => file && openDocument(file)}>
          <ViewDocumentIcon />
        </IconButton>
        <IconButton onClick={() => setFile(null)} sx={{ display: 'flex', alignItems: 'center' }}>
          <DeleteDocumentIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default DocumentDescription;
